import { callDecimal, DecimalResult } from "../utils.ts";
import { Kind } from "../common-types/manageAssets.ts";

const kind12DigitExplore = "EX_ACCESS_CODE";

// interim fix for VST-81300. For jiffy 20 digit codes with only one book the "kind"
// comes back to allow us to use an explore specific toast for a subscription
// hopefully jiffy support will be added to get information for codes with multiple books
// then we can provide more accurate toasts to the user
// todo fix properly when decimal/jiffy provide full transparency

// jiffy 20 digit redemption
interface BookRedemption {
  isbn: string;
  title: string;
  kind?: Kind; // only for codes containing one "book"
}

// bridge 12 digit redemption
interface ExploreRedemption {
  kind: typeof kind12DigitExplore;
}

export type Redemption = BookRedemption | ExploreRedemption;

export interface RedemptionList {
  message: string;
  books: Redemption[];
}

export function isBridgeRedemption(
  asset: Redemption
): asset is ExploreRedemption {
  return asset.kind === kind12DigitExplore;
}

export function redeemCode(code: string) {
  return callDecimal<RedemptionList>("/api/v1/redeem/code", {
    method: "POST",
    body: JSON.stringify({
      code,
    }),
  });
}

export function redeemCodes(
  codes: string[]
): Promise<PromiseSettledResult<DecimalResult<RedemptionList>>[]> {
  // UI allows multiple codes but api doesn't so run concurrent requests
  // note api support for multiple codes might be added in the future
  return Promise.allSettled(codes.map((code) => redeemCode(code)));
}
